export default "__VITE_ASSET__CLFNEoWv__"